/* general functions */
function prevent(event) {
   if (event) event.preventDefault();
}

/* overlay actions */
function overlayClick(event, force = false) {
   if (force || (event.target.classList && (event.target.classList.contains("overlay") || event.target.closest("a") && event.target.closest("a").classList.contains("overlay-closer"))) )
   {
      document.body.classList.remove("show-overlay");
      setTimeout(function() {
         let overlayContent = document.querySelector(".overlay-content")
         overlayContent.innerHTML = "";
         overlayContent.classList.remove("popup-newsletter");
         overlayContent.classList.remove("popup-age-verifier");
         if (overlayContent.dataset.lastPosition) {
            overlayContent.classList.remove(overlayContent.dataset.lastPosition);
            overlayContent.dataset.lastPosition = null;
         }
         overlayContent.classList.add("loading", "overlay-content");
      }, 500)
      unlockBodyPosition();
   }
}
function overlayClear() {
   document.body.classList.remove("show-overlay");
   let overlayContent = document.querySelector(".overlay-content")
   overlayContent.innerHTML = "";
   overlayContent.classList.remove("popup-newsletter");
   overlayContent.classList.remove("popup-age-verifier");
   if (overlayContent.dataset.lastPosition) {
      overlayContent.classList.remove(overlayContent.dataset.lastPosition);
      overlayContent.dataset.lastPosition = null;
   }
   overlayContent.classList.add("loading", "overlay-content");
   unlockBodyPosition();
}

/* Topbar actions */
function openTopbar(event, targetName){
   prevent(event);
   target = document.getElementById(targetName);
   if (target) { 
      document.body.classList.add("topbar-open");
      target.removeAttribute("hidden");
      setTimeout(function () {
         target.classList.add("control-visible");
         let animeOpenTopbar = anime.timeline({
         }).add({
            targets: target,
            duration: 500,
            top: 0,
            easing: 'easeOutQuart',
            complete: function () {target.classList.add("visible");}
         }).add({
            targets: target,
            opacity: 1,
            duration: 200
         }, 0).add({
            targets: target.querySelectorAll(".main-menu>ul>li,.main-menu>form,#localization_form>div,.social-banner"),
            translateY: [-50, 0],
            opacity: [0, 1],
            duration: 525,
            easing: 'easeOutQuart',
            delay: anime.stagger(15, {start: 0})
         },250)
         lockBodyPosition();
         var focusTarget = target.querySelector(".topbar-focus");
         if(focusTarget){ 
            focusTarget.focus();
         }
      },50)
   }
}
function closeTopbar(event) {
   prevent(event);
   let animeCloseTopbar = anime.timeline({
      targets: ".topbar.visible"
   }).add({
      duration: 500,
      top: "-100vh",
      easing: 'easeInQuad',
      complete: function () {
         document.querySelectorAll(".topbar.visible").forEach((el) => {
            el.classList.remove("visible"); el.classList.remove("control-visible");
         })
         document.body.classList.remove("topbar-open");
      }
   }).add({
      duration: 10,
      opacity: 0
   })
   
   if(document.querySelector(".topbar #auth-form"))
      Barracuda.loadPageFromCode("auth-form","login-form",document.querySelector(".topbar #auth-form").dataset.baseURL)
   unlockBodyPosition();
}

/* Functions for blocking scroll when overlay is visible */
function noScroll(event) { 
   var inside = event.target.closest(".scroll-inside");
   if(inside && event.deltaY){
      if(event.deltaY > 0 && inside.scrollTop + inside.offsetHeight < inside.scrollHeight){
      }else if(event.deltaY < 0 && inside.scrollTop > 0){
      }else{
      event.stopPropagation();
      event.stopImmediatePropagation();}
   }
}
function noScrollTouchMove(event) {
   var inside = event.target.closest(".scroll-inside");
   if(inside){
      var noScrollTouchEnd = event.changedTouches[0].clientY;
      if (noScrollTouchStartClientY > noScrollTouchEnd && inside.scrollTop + inside.offsetHeight < inside.scrollHeight) {
      } else if ((noScrollTouchStartClientY < noScrollTouchEnd) && inside.scrollTop > 0) {
      }else{
         event.preventDefault();
         event.stopPropagation();
         event.stopImmediatePropagation();
      }
   }else{
   }
}
function noScrollTouchStart(event){
   noScrollTouchStartClientY = event.touches[0].clientY
}

var bodyPostionY = null;
var noScrollTouchStartClientY = null;
/* lock body scroll */
function lockBodyPosition() {
      Barracuda.setScrollBarWidth();
   document.body.classList.add("no-scroll");
      // add listener to disable scroll
      document.querySelectorAll(".scroll-inside").forEach(el=>{
         el.addEventListener('mousewheel', noScroll, {passive: false});
         el.addEventListener('touchstart', noScrollTouchStart, {passive: false});
         el.addEventListener('touchmove', noScrollTouchMove, {passive: false});
      });
}
function unlockBodyPosition() {
   document.body.classList.remove("no-scroll");
   window.removeEventListener('mousewheel', noScroll,{passive: false});
   window.removeEventListener('touchstart', noScrollTouchStart,{passive: false});
   window.removeEventListener('touchmove', noScrollTouchMove,{passive: false});

}

/* menu actions */
function openSubmenu(event){
   prevent(event);
   var parentLi = event.target.closest("li");
   var height = parentLi.querySelector("ul").style.maxHeight

   parentLi.classList.toggle("open");
   if(height == "") parentLi.querySelector("ul").style.maxHeight = parentLi.querySelector("ul").scrollHeight + "px";
   else parentLi.querySelector("ul").style.maxHeight = "";

   var parentUl = event.target.closest("ul");
   if(parentUl.classList.contains("child")) parentUl.style.maxHeight = (parentUl.scrollHeight + parentLi.querySelector("ul").scrollHeight) + "px";
   
}

/* Fade functions */
Barracuda.duration = 300;
Barracuda.fadeOut = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 1;
      (function fadeOutTemp(){
            el.style.opacity = parseFloat(el.style.opacity) - .02
         if ((el.style.opacity)<0){
            el.classList.add("hide");
            el.dataset.animated = false;
            el.style.opacity = 0;
            if(after) after();}
         else {
            setTimeout(fadeOutTemp,(time / 50))
         }
      })();
   }
};

Barracuda.fadeIn = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 0;
      el.classList.remove("hide");
      (function fadeInTemp(){
            el.style.opacity = parseFloat(el.style.opacity) + .02
         if ((el.style.opacity)>1){
            el.dataset.animated = false;
            el.style.opacity = 1;
            if(after) after();}
         else {
            setTimeout(fadeInTemp,(time / 50))
         }
      })();
   }
}

/* Define methods for dynamic loaded sections */
Barracuda.loadSection = function(){
   document.querySelectorAll(".load-section:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);
         var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
         if(currentContent && currentContent.dataset.source){
            var t = document.querySelector("#"+currentContent.dataset.source);
            if(t) t.appendChild(currentContent);
         }

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false

         if(!targetElement){
            document.querySelector(".overlay-content").innerHTML = "";
            document.querySelector(".overlay-content").classList.add("loading")
            lockBodyPosition();
         }

         var url =  window.location.href;
         if(el.dataset.url){
            var url = el.dataset.url;
         } 
         if((!el.dataset.url && el.closest("form") )|| el.dataset.useform){
            var url = url.split("#")
            var url = url[0] + (url[0].includes("?") ? "&" : "?") + new URLSearchParams(Array.from(new FormData(el.closest("form"))));
         }

         var url = url.split("#")
         var url_section = url[0] + (url[0].includes("?") ? "&" : "?") + "sections=" + el.dataset.section;
         if(el.dataset.urlset)
         { 
            window.history.pushState('', '', url[0]);
         }
         /* console.log("LoadSection: " + url_section); */
         axios.get(url_section)
         .then(function (response) {
            var code = response.data? (response.data[el.dataset.section]? response.data[el.dataset.section] : false):false;
            if (code){
               code = code.replace(/__CURRENT_URL_WITH_APPEND__/g, url[0] + (url[0].includes("?") ? "&" : "?"));
               code = code.replace(/__CURRENT_URL__/g, url[0]);

               if(targetElement){
                  targetElement.classList.remove("loading")

                  if(targetElement.innerHTML!=""){
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(el.dataset.part){
                           var candidate = document.createElement("div");
                           candidate.innerHTML = code;
                           code = candidate.querySelector("."+el.dataset.part);
                           targetElement.innerHTML = "";
                           targetElement.appendChild(code);
                        }else{
                           targetElement.innerHTML = code;
                        }
                        Barracuda.init();
                        Barracuda.elements.init();
                        Barracuda.aos.refreshHard();
                        
                        Barracuda.fadeIn(targetElement,Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }else{
                     if(el.dataset.part){
                        var candidate = document.createElement("div");
                        candidate.innerHTML = code;
                        code = candidate.querySelector("."+el.dataset.part);
                        targetElement.innerHTML = "";
                        targetElement.appendChild(code);
                     }else{
                        targetElement.innerHTML = code;
                     }
                     Barracuda.init();
                     Barracuda.elements.init();
                     Barracuda.aos.refreshHard();
                     Barracuda.setScrollBarWidth();
                  }

               } else {
                  let content = document.querySelector(".overlay-content");
                  content.classList.remove("loading")
                  content.innerHTML = code;
                  lockBodyPosition();
                  document.body.classList.add("show-overlay");
               }
                  Barracuda.init();
                  Barracuda.elements.init();
                  Barracuda.aos.refreshHard();
            } 
         })
         .catch(function (error) {
            if(!targetElement){
               document.querySelector(".overlay-content").classList.remove("loading")
            }
            console.warn(error);
         });
         return false;
      },false)
   });
}
Barracuda.loadPageFromCode = function (targetId, sourceId, url) {
   if(targetId && sourceId && url){
      let targetElement = document.querySelector("#" + targetId);
      axios.get(url)
      .then(function (response) {
         if(response.data){
            var x = document.createElement("html");
            x.innerHTML = response.data;
            var source = x.querySelector("#"+ sourceId);
            if(source){
               targetElement.innerHTML = "";
               targetElement.appendChild(source);

               Barracuda.init();
               Barracuda.elements.init();
               Barracuda.aos.refreshHard();
            }
            return false;
         }
         return false;
      })
      .catch(function (error) {
         console.error(error);
         return false;
      });
   }
}
/* Dynamic load page - part page */
Barracuda.loadPage = function(){
   document.querySelectorAll(".load-page:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false
         var sourceId = el.dataset.source? el.dataset.source : (el.dataset.target? el.dataset.target: false);
         var url = el.dataset.url? el.dataset.url : (el.href? el.href : false);
         url = (url.split("#"))[0];
         
         if(el.dataset.urlset && el.closest(".topbar")==null) window.history.pushState('', '', url);

         if(targetElement && sourceId && url){
            /* console.log("BarracudaLoadPage: urlset: "+el.dataset.urlset+", url: "+ url +", sourceId: #"+sourceId+", target:", targetElement) */
            targetElement.classList.add("loading");

            if(sourceId == "pagination"){
               /* console.log("BarracudaLoadPage: Pagination - scroll up ", targetElement.offsetTop) */
               if(targetElement.offsetTop - 200 < 200)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
               else
                  window.scrollTo({top: (targetElement.offsetTop - 200), left: 0, behavior: 'smooth'})

            }

            axios.get(url)
            .then(function (response) {
               if(response.data){
                  var x = document.createElement("html");
                  x.innerHTML = response.data;
                  var source = x.querySelector("#"+ sourceId);
                  if(source){
                     el.parentElement.querySelectorAll(".load-page.active").forEach(function (y){
                        y.classList.remove("active");
                     })
                     el.classList.add("active")
                     
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(sourceId != "pagination"){
                           targetElement.innerHTML = "";
                           targetElement.appendChild(source);
                        }else{
                           source.classList.add("hide", "loading")
                           targetElement.replaceWith(source);
                           targetElement = source;
                        }
                        targetElement.classList.remove("loading")

                        Barracuda.init();
                        Barracuda.elements.init();
                        Barracuda.aos.refreshHard();

                        Barracuda.fadeIn(targetElement, Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }
                  return false;
               }
               return false;
            })
            .catch(function (error) {
               console.error(error);
            });
         }
         return false;
      },false)
   });
}
/* Show template in overlay */
Barracuda.templateOverlay = function(){
   document.querySelectorAll(".template-overlay:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click", (e) => {
         console.log(111)
         prevent(e);
         var template = document.getElementById(el.dataset.source);
         let target = document.querySelector(".overlay-content");
         if(template){
            target.classList.add("loading");
            lockBodyPosition();
   
            var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
               
            if(currentContent && currentContent.dataset.source && document.querySelector("#"+currentContent.dataset.source))
               document.querySelector("#"+currentContent.dataset.source).appendChild(currentContent);

            target.innerHTML = "";

            var closer = document.createElement("a");
            closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
            closer.classList.add("icon","icon-x","overlay-closer");
            
            var content = document.createElement("div");
            content.innerHTML = template.innerHTML;
            content.classList.add("overlay-content-content","quick-view","quick-view-form","scroll-inside");
            if (template.dataset.type) content.classList.add(...template.dataset.type.split(" "));
            
            target.appendChild(closer);
            target.appendChild(content);

            if(content.querySelector(".map")){
               setTimeout(function() { 
                  Barracuda.loadMapsScript(content);
               },200);
            }

            Barracuda.init();
            Barracuda.elements.init();
            Barracuda.aos.refreshHard();
            target.classList.remove("loading");
            document.body.classList.add("show-overlay");
         }
      })
   })
}
/* Define methods for dynamic collapse elements */
Barracuda.toggleCollapsible = function(e) {
   prevent(e);
   var opener = e.target.closest(".collapse-toggle")
   if(opener){
      var element = document.getElementById(opener.dataset.target);
      if(element.classList.contains("collapsed")){
         element.style.height = element.scrollHeight + "px";
         element.classList.remove("collapsed");
         setTimeout(()=>{
            element.style.height = "auto";
         }, 500);
         opener.classList.add("opened");
      }else{
         element.style.height = element.scrollHeight + "px";
         setTimeout(()=>{
            element.style.height = 0 + "px";
         },10);
         element.classList.add("collapsed");
         opener.classList.remove("opened");
      }
   }
}

/* Add event listeners for dynamic collapse elements */
Barracuda.initCollapsible = function(){
   document.querySelectorAll(".collapse-toggle:not(.collapse-toggle-initialized)").forEach(el => {
      el.addEventListener("click",Barracuda.toggleCollapsible);
      el.classList.add("collapse-toggle-initialized");
   })
}

/* Create autoresize textarea element */
Barracuda.textareaAutoresize = function(){
   document.querySelectorAll("textarea.autoresize:not(.autoresize-initialized)").forEach(el => {
      el.addEventListener("keyup",(e)=>{
         e.target.style.height = "0px";
         e.target.style.height = (e.target.scrollHeight - (el.dataset.correction? el.dataset.correction : 26)) + "px";
      })
      el.classList.add("autoresize-initialized");
   })
}

/* Close section and save it to cookies */
Barracuda.cookieSection = function(){
   document.querySelectorAll(".hide-by-cookie-section:not(.hide-by-cookie-section-initialized)").forEach((el)=>{
      var dataEl = el.querySelector(".hide-by-coookie-data");
      var respawn_time = el.dataset.respawn? parseInt(el.dataset.respawn) : parseInt(dataEl? (dataEl.dataset.respawn? dataEl.dataset.respawn : 0) : 0);
   
      el.classList.add("hide-by-cookie-section-initialized")
      if (BarracudaStore.functions.getCookie('cookie-' + el.id + '-' + respawn_time) != "closed" || Shopify.designMode) {
         el.classList.remove("hide-by-cookie");
         el.querySelectorAll(".hide-by-cookie-toggle").forEach(toggle=>{
            toggle.addEventListener("click",()=>{
               if(el.querySelector(".badge-section")){
                  Barracuda.fadeOut(el.querySelector(".badge-section"),()=>{
                     el.classList.add("hide-by-cookies");
                  }, (Barracuda.duration * 2));
               }
               /* if(el.classList.contains("announcement-bar-content"))
               {    
                  document.documentElement.style.setProperty('--announcement-bar-height', 0 + "px");
                  el.style.height = parseInt(el.offsetHeight) + "px";
                  el.style.overflow = "hidden";
                  el.style.transition = "height 1s ease";
                  el.style.minHeight = "0px";
                  el.style.height = "0px";
                  setTimeout(function(){Barracuda.initAddHeight();
                  },1000)

               } */
               /* console.log("Cookies - element: ", el, " repsawn_time: ", respawn_time) */
               // respawn_time is in days
               if(respawn_time > 0) setCookie('cookie-'+el.id+'-'+respawn_time,"closed",respawn_time);
            },false);
         })
      }
   })
}

Barracuda.loadMapsScript = function(content = null){
   if(!document.getElementById("ol-script")){
      var tag = document.createElement("script");
      tag.id = "ol-script"
      tag.src = document.querySelector(".ol-url")? document.querySelector(".ol-url").dataset.url : "";
      document.getElementsByTagName("head")[0].appendChild(tag);

      window.removeEventListener("scroll", Barracuda.elements.lazyMapsListener)
   }else{
      if(content)
         content.querySelectorAll(".map.map-initialized").forEach(element => {
            element.dispatchEvent(new Event('renderMap'))
         })
      document.querySelectorAll(".map:not(.map-initialized)").forEach(element => {
         new BarracudaMap(element)
      })
   }
}
Barracuda.checkMaps = function(){
   if(typeof BarracudaMap === "undefined"){
      Barracuda.elements.lazyMaps.forEach((element, index)=>{
         if(!document.getElementById("ol-script") && element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
            Barracuda.loadMapsScript();
            window.removeEventListener("scroll", Barracuda.checkMaps, {passive: true});
         }
      })
   }
}
Barracuda.checkVideos = function(){
   Barracuda.elements.lazyVideos.forEach((element, index)=>{
   if(element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
      element.src = element.dataset.src;
      var video = element.closest("video");
      if(video && video.play && video.autoplay ) video.play();

      Barracuda.elements.lazyVideos.splice(index, 1);
      if(Barracuda.elements.lazyVideos.length==0) 
         window.removeEventListener("scroll", Barracuda.elements.lazyVideosListener)
   }
   })
}

/* Function which adding spaces between sections with differents backgrounds */
Barracuda.sectionPaddingForBackgroundsTwo = function(ignoreSection = false){

}

/* Function which keep elements squared. */
Barracuda.toSquare = function(){
   document.querySelectorAll(".square").forEach((element) => {
   var width = element.offsetWidth;
   /* console.log("square: ",element, "width: ",width) */
   element.style.height = width + "px";
   })
}

Barracuda.setScrollBarWidth = function(){
   if(!document.querySelector(".topbar.visible")){
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      if(scrollbarWidth < 60 && (scrollbarWidth + "px" != getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width')))
      document.body.style.setProperty("--scrollbar-width",scrollbarWidth + "px");
   }
}
/* Define scrollbar width and height */
Barracuda.setScrollBarWidth();

/* Inicialization for barracuda functions */
Barracuda.init = function(){
   Barracuda.reInit();
      window.addEventListener("resize", ()=>{
         Barracuda.toSquare();
         Barracuda.setScrollBarWidth();
         /* Barracuda.initAddHeight(); */
      }); 
   if(Barracuda.elements.lazyVideos.length>0){
      Barracuda.elements.lazyVideosListener = window.addEventListener("scroll", Barracuda.checkVideos, {passive: true});
      setTimeout(Barracuda.checkVideos, 3000);
   }
   if(Barracuda.elements.lazyMaps.length>0){
      Barracuda.elements.lazyMapsListener = window.addEventListener("scroll", Barracuda.checkMaps, {passive: true});
      setTimeout(Barracuda.checkMaps, 3000);
   }
}
/* ReInit after Shopify Theme editor changes something  */
Barracuda.reInit = function(){
   Barracuda.cookieSection();
   Barracuda.initCollapsible();
   Barracuda.loadSection();
   Barracuda.loadPage();
   Barracuda.sectionPaddingForBackgroundsTwo();
   Barracuda.textareaAutoresize(); 
   Barracuda.toSquare();
  /*  Barracuda.initAddHeight(); */
   Barracuda.checkVideos();
   Barracuda.checkMaps();
   Barracuda.templateOverlay();
}

/* System for Dynamic colors when overlay inverted elements. */
class BarracudaOverlapping{
   constructor(){
      this.setOverlaping();
      window.addEventListener("scroll", this.setOverlaping.bind(this));
      window.addEventListener("resize", this.setOverlaping.bind(this));
      document.addEventListener("section:colorChange", this.setOverlaping.bind(this));
   }
   setOverlaping(){
      document.querySelectorAll(".sidebar .icon svg,.change-color-overlap").forEach(el=>{
            var overlap = false;
         document.querySelectorAll(".use-inverted-colors.full-width.first-of-content, .first-of-content .full-width.use-inverted-colors ").forEach(background => {
               if(BarracudaStore.functions.isOverlapping(el, background))
                  overlap = true;
            });
            if(overlap) 
                     el.classList.add("use-inverted-colors");
            else
                     el.classList.remove("use-inverted-colors");
      });
      document.querySelectorAll("#header.can-be-transparent").forEach(el => {
         var overlap = false;
         document.querySelectorAll(".header-can-overlap").forEach(background => {
            if (BarracudaStore.functions.isOverlapping(el, background)) {
               overlap = true;
            }
         })
         if (overlap) {
            el.classList.add("should-be-transparent")
         }
         else {
            el.classList.remove("should-be-transparent")
         }
      })
   }
   check(){
      this.setOverlaping();
   }
   
}


class BarracudaAnimatedMenu{
   constructor(){
   this.debug = true;
   this.hidden = false;
   this.menu = document.querySelector(".main-menu");
   this.linksInMenu = this.menu? this.menu.querySelectorAll("ul:not(.child):not(.grandchild)>li"): false;
   
   }
   hideMenuLinks(){
      if(!this.hidden){
         this.hidden = true;
         this.linksInMenu.forEach(function (link) {
            link.dataset.height = link.clientHeight + 1;
            link.style.maxHeight = 0 + "px";
            link.style.overflow = "hidden";
            link.style.transition = "max-height 0.55s cubic-bezier(0.32, 0.08, 0.24, 1)";
         })
      }
   }
   showMenuLinks(i = 0){
      if(i == 0) this.hidden = false;
      var link = this.linksInMenu[i];
      if(link){
         link.style.maxHeight = link.dataset.height + "px";
         setTimeout((function (){this.removeSettings(link)}).bind(this), 1000);
         setTimeout((function (){this.showMenuLinks(++i)}).bind(this), 6);
      }
   }
   removeSettings(link){
      if(link){
         link.style.transition = "";
         link.style.maxHeight = "";
         link.style.overflow = "";
      }
   }
}

class BarracudaRichMedia{
   constructor(element){
      this.element = element;
      this.mediaid = element.dataset.mediaid;
      this.template = document.getElementById("templateid-"+this.mediaid);
      this.container = document.getElementById("containerid-"+this.mediaid);
      this.cover = this.element;
      this.media = null
      this.type = null

      if(this.template && this.container){
         /* Add listener to show button */
         console.log(this.element.parentElement)
         this.element.parentElement.querySelector("button.media-icon").addEventListener("click",this.show.bind(this), false);
      }else{
         console.error("BarracudaRichMedia: Rich media not found - container or template", this.template, this.container)
      }
   }
   getType(){
      if(this.container.querySelector(".js-youtube")){
         this.media = this.container.querySelector(".js-youtube");
         this.type = "youtube";
      }
      if(this.container.querySelector(".js-vimeo")){
         this.media = this.container.querySelector(".js-vimeo");
         this.type = "vimeo";
      }
      if(this.container.querySelector("video")){
         this.media = this.container.querySelector("video");
         this.type = "video";
      }
   }

   play(){
      console.log("BarracudaRichMedia: play", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "video":
            this.media.play();
            break;
      }
   }
   pause(){
      console.log("BarracudaRichMedia: pause", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "video":
            this.media.pause();
            break;
      }
   }
   hide(){
      console.log("BarracudaRichMedia: hide", this.mediaid);
      this.container.innerHTML = "";
      this.cover.classList.remove("hidden");
      this.container.classList.add("hidden");
   }
   show(){
      console.log("BarracudaRichMedia: show", this.mediaid);
      /* this.cover.classList.add("hidden"); */
      this.container.classList.remove("hidden");
      this.container.innerHTML = this.template.innerHTML;
      this.getType();

      this.stopOthers();
      this.play();
      setTimeout(this.play.bind(this),100);
   }
   stopOthers(){
      for (const [key, value] of Object.entries(Barracuda.elements.richMedia)) {
         if(key != this.mediaid)
            value.pause();
       }
   }
}

Barracuda.aos = {
   'init': () => { 
      if (!Shopify.designMode && typeof AOS !== 'undefined') {
         AOS.init({
         offset: 0, // offset (in px) from the original trigger point
         delay: 0,
         duration: 600
         });
      }
   },
   'refresh': () => {
      if (!Shopify.designMode && typeof AOS !== 'undefined') {
         AOS.refresh()
      }
   },
   'refreshHard': () => {
      if (!Shopify.designMode && typeof AOS !== 'undefined') {
         AOS.refreshHard()
      }
   }
}


// 



document.addEventListener('DOMContentLoaded', function() {
    // MutationObserver to detect dynamically added elements
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                // Check if the added node has the necessary class and data-value
                if (node.nodeType === 1 && node.matches('.swatch.not-color.disabled')) {
                    // Insert the "Not in stock" message with red color
                    addNotInStockMessage(node);
                }
            });
        });
    });

    // Observe the entire document for added elements
    observer.observe(document.body, {
        childList: true, // Watch for child nodes added or removed
        subtree: true, // Watch all descendant nodes
    });

    // Also, ensure the "Not in stock" message works for pre-existing elements
    document.querySelectorAll('.swatch.not-color.disabled').forEach(function(element) {
        addNotInStockMessage(element);
    });

    // Function to add the "Not in stock" message
    function addNotInStockMessage(element) {
        if (!element.querySelector('.not-in-stock-message')) {
            // Create a small element with the message
            const message = document.createElement('small');
            message.classList.add('not-in-stock-message');
            message.textContent = '(Sold Out)';
            // Style the message with red color
            message.style.color = 'grey';
            // Append the message below the element's text
            element.appendChild(message);
        }
    }
});
